import { TeamOutlined, UserOutlined } from "@ant-design/icons";
import { Descriptions, Tag } from "antd";
import { Link } from "react-router-dom";
import type { Territory } from "../services/territory.service";

interface TerritoryInfoCardProps {
	territory: Territory;
}

/** Descriptions block with the territory's main attributes */
export function TerritoryInfoCard({ territory }: TerritoryInfoCardProps) {
	return (
		<Descriptions
			size="small"
			column={2}
			items={[
				{
					key: "organization",
					label: "Tashkilot",
					children: territory.organizationName || "—",
				},
				{
					key: "area",
					label: "Yuzasi",
					children: `${territory.area?.toLocaleString("uz-UZ") ?? "—"} m²`,
				},
				{
					key: "perimeter",
					label: "Perimetr",
					children: `${territory.perimeter?.toLocaleString("uz-UZ") ?? "—"} m`,
				},
				{
					key: "brigades",
					label: (
						<span className="flex items-center gap-1">
							<TeamOutlined /> Brigadalar
						</span>
					),
					children:
						territory.assignedBrigades && territory.assignedBrigades.length > 0 ? (
							<div className="flex flex-wrap gap-1">
								{territory.assignedBrigades.map((b) => (
									<Link key={b.id} to={`/brigades/${b.id}`}>
										<Tag color="blue" className="cursor-pointer">
											{b.name}
										</Tag>
									</Link>
								))}
							</div>
						) : (
							"—"
						),
				},
				{
					key: "taskCount",
					label: "Vazifalar",
					children: <Tag>{territory.taskCount ?? 0}</Tag>,
				},
				{
					key: "plantingCount",
					label: "Ekinlar",
					children: <Tag>{territory.plantingCount ?? 0}</Tag>,
				},
				{
					key: "staff",
					label: (
						<span className="flex items-center gap-1">
							<UserOutlined /> Biriktirilgan xodimlar
						</span>
					),
					span: 2,
					children:
						territory.assignedStaff && territory.assignedStaff.length > 0 ? (
							<div className="flex flex-wrap gap-1">
								{territory.assignedStaff.map((s) => (
									<Tag key={s.id} color={s.isPrimary ? "blue" : "default"}>
										{s.fullname}
										{s.isPrimary ? " (asosiy)" : ""}
									</Tag>
								))}
							</div>
						) : (
							"—"
						),
				},
			]}
		/>
	);
}
